<template>
    <v-layout row>
    <v-flex xs12 sm12>
        <v-card class="elavation-1 transparent">
            <v-toolbar class="transparent" flat height="37">
                <v-btn dark icon title="Back to cut off list" @click="$router.go(-1)">
                    <v-icon>arrow_back</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <!-- <v-btn v-if="!closed_Status" dark icon title="Send email reminder to all employees" @click="showSendReminder">
                    <v-icon>notification_important</v-icon>
                </v-btn> -->
                <v-menu v-if="!loading&&hasEditRights" left v-model="menu_status" offset-y> <!--:disabled="closed_Status"--> 
                    <template v-slot:activator="{ on }">
                        <v-btn :color="commonfn.getStatusButtonColor(cutoff_status)" dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;{{commonfn.getStatusDescription(cutoff_status)}}&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                    </template>
                    <v-list dense v-show="open_Status||closed_Status">
                        <v-list-tile :key="0" @click="freezePriod" title="Freeze this period">
                            <v-list-tile-title small>Freeze</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                    <v-list dense v-show="frozen_Status||closed_Status">
                        <v-list-tile :key="1" @click="reOpenPeriod" title="Re-open this period">
                            <v-list-tile-title small>Re-open</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                    <v-list dense v-show="frozen_Status">
                        <v-list-tile :key="2" @click="closePeriod" title="Close this period">
                            <v-list-tile-title small>Close</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar>
            <v-progress-linear v-if="loading" indeterminate color="primary" height="3" style="margin:1px -3px 0px -3px;"></v-progress-linear>
        </v-card>
        <v-alert v-if="error" :value="true" color="error" icon="error" outline>
            {{errorMessage}}
        </v-alert>
        <v-expansion-panel v-model="panel" expand style="margin-top:5px;">
            <!-- CUTOFF COVERAGE -->
            <v-expansion-panel-content>
                <template v-slot:header>
                    <span class="font-weight-bold">CUTOFF COVERAGE</span>
                    <v-spacer></v-spacer>
                </template>
                <v-card class="elavation-1 transparent">
                    <v-card-text>
                        <v-layout wrap row>
                            <v-flex xs12>
                                <v-layout wrap row>
                                    <v-flex xs5 class="text-xs-right">
                                        From :
                                    </v-flex>
                                    <v-flex xs7 class="text-xs-left">
                                        <span class="font-weight-bold">{{this.cutoff_period.cutoffStart|moment('MMMM D, YYYY')}}</span>
                                    </v-flex>
                                </v-layout>
                                <v-layout wrap row>
                                    <v-flex xs5 class="text-xs-right">
                                        To :
                                    </v-flex>
                                    <v-flex xs7 class="text-xs-left">
                                        <span class="font-weight-bold">{{this.cutoff_period.cutoffEnd|moment('MMMM D, YYYY')}}</span>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-expansion-panel-content>

            <!-- AUDIT REPORT -->
            <v-expansion-panel-content>
                <template v-slot:header>
                    <span class="font-weight-bold">AUDIT REPORT</span>
                    <v-spacer></v-spacer>
                </template>
                <v-card class="elavation-1 transparent"> 
                    <v-data-table
                        :headers="headers"
                        :items="cutoff_audit"
                        :rows-per-page-items="rowsPerPageItems"
                        :pagination.sync="paginationSync"
                    >
                        <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                        <template v-slot:items="props">
                            <tr >
                            <td>{{ props.item.transDate | moment("YYYY-MM-DD (ddd)") }}</td>
                                <td>
                                    {{ props.item.dateDetails }}
                                </td>
                                <td>
                                    <div v-if="props.item.totalChargeableHours!=0">{{ numFormat.formatNumber(props.item.totalChargeableHours) }}</div>
                                </td>
                                <td>
                                    <div v-if="props.item.chargeableHoursCorrections!=0">{{ numFormat.formatNumber(props.item.chargeableHoursCorrections) }}</div>
                                </td>
                                <td>
                                    <div v-if="props.item.otHours!=0">{{ numFormat.formatNumber(props.item.otHours) }}</div>
                                </td>
                                <td>
                                    <div v-if="props.item.projectChargesApproved!=0">{{ numFormat.formatNumber(props.item.projectChargesApproved) }}</div>
                                </td>
                                <td>
                                    <div v-if="props.item.projectChargesUnApproved!=0">{{ numFormat.formatNumber(props.item.projectChargesUnApproved) }}</div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-expansion-panel-content>
         </v-expansion-panel>

         <!-- Comments and Updates -->
        <v-layout row wrap>
            <v-flex xs12 sm6>
                <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
            </v-flex>
            <v-flex xs12 sm6>
                <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
            </v-flex>
        </v-layout>
    </v-flex>
   
    <v-dialog v-model="dialogEmail" persistent width="550" >
      <email-reminder ref="reminderRef" :dialogEmail.sync="dialogEmail" ></email-reminder>
    </v-dialog>

    <!-- status messaging component -->
    <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout>  
</template>
<script>

import cutoffApi from '@/api/cutoff'
import numFormat from '@/common/num_format'
import commonfn from '@/common/functions'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {     
    name: 'CompanyCutoffPeriods',
    metaInfo: {
        title: 'Company Cutoff Periods',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Company Cutoff Periods' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'email-reminder': () => import('@/components/CutOff/CutOffReminder'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },   
    data () {
        return {
            commonfn,
            numFormat,
            rowsPerPageItems,
            error: false,
            errorMessage: '',
            loading: false,
            loading_status: false,
            loggedInTeamId: null,
            panel: [true],
            disabled: false,
            menu_status: false,
            cutoff_period: [],        
            cutoff_audit: [],
            dialogAddEdit: false,
            expand: false,
            toggle_view: 2,
            paginationSync: {rowsPerPage: userPrefs.getRowsPerPage(this.$route.name)},
            headers: [
                {text: 'Date', align: 'left',value: '',sortable:false,},
                {text: 'Date Notes',align: 'left',value: '',sortable:false},
                {text: 'Attendance',align: 'left',value: '',sortable:false},
                {text: 'Attendance Corrections',align: 'left',value: '',sortable:false},
                {text: 'Overtime',align: 'left',value: '',sortable:false},
                {text: 'Approved Tasks',align: 'left',value: '',sortable:false},
                {text: 'UnApproved Tasks',align: 'left',value: '',sortable:false},
            ],
            dialogEmail: false,
        }
    },
    methods: {
        showSendReminder() {
            this.$refs.reminderRef.setCutOffId(this.selectedCutoffId)
            this.dialogEmail=true
        },
        showEdit() {
            this.$refs.addEditCutOff.setEditParams(this.cutoff_period)
            this.dialogAddEdit = true
        },
        async reOpenPeriod() {
            try{
                this.loading_status = true
                var data = {
                    cutoffId : this.selectedCutoffId
                }

                //this can be improved, return updated cutoff object in cutoffApi.undofreeze
                //then no need to retrieve using getCutoffPeriod
                await cutoffApi.undofreeze(data) 
                await this.getCutoffPeriod(false)

                this.loading_status = false

            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async closePeriod() {
            try{
                this.loading_status = true
                var data = {
                    cutoffId : this.selectedCutoffId
                }

                //this can be improved, return updated cutoff object in cutoffApi.close
                //then no need to retrieve using getCutoffPeriod
                await cutoffApi.close(data)
                await this.getCutoffPeriod(false)

                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async freezePriod(){
            try{
                this.loading_status = true
                var data = {
                    cutoffId : this.selectedCutoffId
                }

                //this can be improved, return updated cutoff object in cutoffApi.freeze
                //then no need to retrieve using getCutoffPeriod
                await cutoffApi.freeze(data)
                await this.getCutoffPeriod(false)

                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        viewAllTimereports() {
            this.$router.push('/company/timereport')
        },
        viewAllCutOffs() {
            this.$router.push('/company/cutoffs')
        },
        async getCutoffPeriod(show_loading){
            try{
                this.loading = show_loading
                const response = await cutoffApi.getById(this.selectedCutoffId)
                if (response && response.status == 200) {
                    this.cutoff_period = response.data
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getCutoffAudit(){
            try{
                const response = await cutoffApi.getAudit(this.selectedCutoffId)
                if (response && response.status == 200) {
                    this.cutoff_audit = response.data.items
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        editHandler() {
            this.getCutoffPeriod(false)
            this.getCutoffAudit()
        },      
        updateHandler(data) {
            this.getCutoffPeriod(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }  
    },
    async created() { 
        await this.getCutoffPeriod(true)

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: `${this.cutoff_period.fiscalYear} Calendar Period`
        })
        this.getCutoffAudit()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal);
        }
    },
    computed: {
        pageQueryId() {
            return `cutoff${this.selectedFiscalPeriodId}${this.selectedCutoffId}`
        },
        hasEditRights() {
            return commonfn.hasEditRights(this.$router.currentRoute.path)
        },
        hasApproverRights() {
            return commonfn.hasApproverRights(this.$router.currentRoute.path)
        },
        selectedCutoffId() {
            return this.$route.params.cutoffId
        },
        selectedFiscalPeriodId() {
            return this.$route.params.fiscalPeroidId
        },
        commentsData() {
            if (!this.loading) {
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: null,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.cutoff,
                    notificationTypeId: notificationTypes.cutoff
                }
            }
        },     
        cutoff_status() {
            if (this.cutoff_period) return this.cutoff_period.status
            else return ''
        },
        open_Status() {
            if (this.cutoff_period)
                return this.cutoff_period.status==commonfn.getStatusCode('Open')
        },
        frozen_Status() {
            if (this.cutoff_period)
                return this.cutoff_period.status==commonfn.getStatusCode('Frozen')
        },
        closed_Status() {
            if (this.cutoff_period)
                return this.cutoff_period.status==commonfn.getStatusCode('Closed')
        },
        selectedFiscalYear() {
            if (this.cutoff_period)
                return this.cutoff_period.fiscalYear
        },
    }
  }
</script>